import React from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import axios from "../../utils/axios";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaEdit, FaTrash, FaCheck, FaTimes, FaPlus } from "react-icons/fa";
import { motion } from "framer-motion";
import { WithContext as ReactTags } from 'react-tag-input';
import Swal from 'sweetalert2';

const MembershipPlans = (props) => {
  const [plans, setPlans] = useState([]);
  const [modal, setModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [newPlan, setNewPlan] = useState({
    name: '',
    description: '',
    head_line: '',
    features: [],
    price: '',
    billing_cycle: 'yearly',
    is_active: true,
    sort_order: ''
  });
  const [tags, setTags] = useState([]);
  const [suggestions, setSuggestions] = useState([]);

  const breadcrumbItems = [
    { title: "Membership Plans", link: "#" },
    { title: "All Plans", link: "#" },
  ];

  useEffect(() => {
    fetchPlans();
    setSuggestions([
        { id: '1', text: '24/7 Support' },
        { id: '2', text: 'Premium Content' },
        { id: '3', text: 'Exclusive Access' },
        { id: '4', text: 'Discounts' },
        { id: '5', text: 'Early Access' }
      ]);
    props.setBreadcrumbItems('Membership Plans', breadcrumbItems);
  }, []);

  const fetchPlans = () => {
    try {
      axios.get('/api/membership-plans')
        .then(response => {
          setPlans(response.data.data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewPlan({
      ...newPlan,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleDelete = (i) => {
    // Create a new array without the deleted tag
    const newTags = tags.filter((tag, index) => index !== i);
    setTags(newTags);
  };

  const handleAddition = (tag) => {
    // Ensure the tag has both id and text properties
    const newTag = {
      id: `tag-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
      text: tag.text || tag
    };
    setTags([...tags, newTag]);
  };

  const handleDrag = (tag, currPos, newPos) => {
    const newTags = tags.slice();
    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);
    setTags(newTags);
  };

  const handleTagClick = (index) => {
    console.log('The tag at index ' + index + ' was clicked');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Convert tags to features array
    const features = tags.map(tag => tag.text);
    
    const planData = {
      ...newPlan,
      features: features,
      is_active: newPlan.is_active ? 1 : 0
    };

    if(editingId != null){
        axios.put(`/api/membership-plans/${editingId}`, planData)
        .then(response => {
            Swal.fire(
              'Success!',
              'Plan has been updated successfully.',
              'success'
            );
            fetchPlans(); // Refresh the plans list
            toggleModal(); // Close the modal
            setNewPlan({
              name: '',
              description: '',
              head_line: '',
              features: [],
              price: '',
              billing_cycle: 'yearly',
              is_active: true,
              sort_order: ''
            });
            setTags([]);
            setEditingId(null);
          })
          .catch(error => {
            Swal.fire(
              'Error!',
              'Failed to update plan. Please try again.',
              'error'
            );
            console.error('Error updating plan:', error);
          });
    }else{
        axios.post('/api/membership-plans', planData)
        .then(response => {
            Swal.fire(
              'Success!',
              'Plan has been added successfully.',
              'success'
            );
            fetchPlans(); // Refresh the plans list
            toggleModal(); // Close the modal
            setNewPlan({
              name: '',
              description: '',
              head_line: '',
              features: [],
              price: '',
              billing_cycle: 'yearly',
              is_active: true,
              sort_order: ''
            });
            setTags([]);
            setEditingId(null);
          })
          .catch(error => {
            Swal.fire(
              'Error!',
              'Failed to add plan. Please try again.',
              'error'
            );
            console.error('Error adding plan:', error);
          });
    }

  };

  const toggleModal = () => setModal(!modal);



  const handleEdit = (planId) => {
    console.log("Edit plan with id:", planId);
    axios.get(`/api/membership-plans/${planId}`)
      .then(response => {
        const plan = response.data.data;
        let features = [];
        
        // Parse features if it's a string, otherwise use as is
        try {
          features = typeof plan.features === 'string' 
            ? JSON.parse(plan.features) 
            : plan.features || [];
        } catch (e) {
          console.error('Error parsing features:', e);
          features = [];
        }
  
        setNewPlan({
          name: plan.name,
          description: plan.description,
          head_line: plan.head_line,
          features: features,
          price: plan.price,
          billing_cycle: plan.billing_cycle,
          is_active: plan.is_active,
          sort_order: plan.sort_order
        });
  
        // Convert features array to tags format
// Convert features array to tags format with proper IDs
setTags(features.map((feature, index) => {
    const text = typeof feature === 'object' ? feature.text || JSON.stringify(feature) : feature;
    return {
      id: `tag-${index}-${Date.now()}`, // Create a unique ID
      text: text
    };
  }));
        
        setEditingId(planId);
        toggleModal();
      })
      .catch(error => {
        Swal.fire(
          'Error!',
          'Failed to fetch plan. Please try again.',
          'error'
        );
        console.error('Error fetching plan:', error);
      });
  };

  const handleDeletePlan = (planId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`/api/membership-plans/${planId}`)
          .then(response => {
            Swal.fire(
              'Deleted!',
              'Plan has been deleted successfully.',
              'success'
            );
            fetchPlans();
          })
          .catch(error => {
            console.error('Error deleting plan:', error);
            Swal.fire(
              'Error!',
              'Failed to delete plan. Please try again.',
              'error'
            );
          });
    }
    });
  };

  const settings = {
    dots: true,
    infinite: plans.length > 1,
    speed: 500,
    slidesToShow: Math.min(3, plans.length),
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(2, plans.length),
          slidesToScroll: 1,
          infinite: plans.length > 1,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className="membership-plans-container">
      <Row>
        <Col>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <CardTitle className="mb-0">
                  <h4>Membership Plans</h4>
                </CardTitle>
                <Button color="primary" onClick={toggleModal}>
                  <FaPlus className="mr-1" /> Add New Plan
                </Button>
              </div>
              
              {plans.length > 0 ? (
                <div className="slider-container">
                  <Slider {...settings}>
                    {plans.map((plan) => (
                      <motion.div 
                        key={plan.id}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                      >
                        <div className="px-2 h-100">
                          <Card className="plan-card h-100">
                            <CardBody className="d-flex flex-column h-100">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className="mb-0">{plan.name}</h3>
                                <div>
                                  <Button 
                                    color="link" 
                                    className="p-0 mr-2"
                                    onClick={() => handleEdit(plan.id)}
                                  >
                                    <FaEdit className="text-primary" />
                                  </Button>
                                  <Button 
                                    color="link" 
                                    className="p-0"
                                    onClick={() => handleDeletePlan(plan.id)}
                                  >
                                    <FaTrash className="text-danger" />
                                  </Button>
                                </div>
                              </div>
                              
                              <div className="text-center mb-4">
                                <h2 className="text-primary">${plan.price}</h2>
                                <span className="badge badge-soft-primary">
                                  {plan.billing_cycle}
                                </span>
                              </div>
                              
                              <p className="text-muted mb-4">{plan.description}</p>
                              <h6 className="mb-3">{plan.head_line}</h6>
                              
                              <ul className="list-unstyled plan-features mb-4">
                                {plan.features.map((feature, index) => (
                                  <li key={index} className="mb-2">
                                    <FaCheck className="text-success mr-2" />
                                    {feature}
                                  </li>
                                ))}
                              </ul>
                              
                              <div className="mt-auto">
                                <Button color="primary" block className="mb-3">Choose Plan</Button>
                                <div className="text-center">
                                  <small className="text-muted">
                                    {plan.is_active ? (
                                      <span className="text-success">
                                        <FaCheck className="mr-1" /> Active
                                      </span>
                                    ) : (
                                      <span className="text-danger">
                                        <FaTimes className="mr-1" /> Inactive
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </div>
                      </motion.div>
                    ))}
                  </Slider>
                </div>
              ) : (
                <div className="text-center py-4">
                  <p>No membership plans available</p>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Add New Plan Modal */}
      <Modal isOpen={modal} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>
          {editingId ? 'Edit Membership Plan' : 'Add New Membership Plan'}
        </ModalHeader>
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="name">Plan Name</Label>
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    value={newPlan.name}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="price">Price ($)</Label>
                  <Input
                    type="number"
                    name="price"
                    id="price"
                    value={newPlan.price}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="billing_cycle">Billing Cycle</Label>
                  <Input
                    type="select"
                    name="billing_cycle"
                    id="billing_cycle"
                    value={newPlan.billing_cycle}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="sort_order">Sort Order</Label>
                  <Input
                    type="number"
                    name="sort_order"
                    id="sort_order"
                    value={newPlan.sort_order}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            
            <FormGroup>
              <Label for="head_line">Headline</Label>
              <Input
                type="text"
                name="head_line"
                id="head_line"
                value={newPlan.head_line}
                onChange={handleInputChange}
                required
              />
            </FormGroup>
            
            <FormGroup>
              <Label for="description">Description</Label>
              <Input
                type="textarea"
                name="description"
                id="description"
                value={newPlan.description}
                onChange={handleInputChange}
                required
              />
            </FormGroup>
            
            <FormGroup>
              <Label>Features (Press Enter to add)</Label>
              <ReactTags
                  tags={tags}
                  suggestions={suggestions}
                  handleDelete={handleDelete}
                  handleAddition={handleAddition}
                  handleDrag={handleDrag}
                  handleTagClick={handleTagClick}
                  inputFieldPosition="inline"
                  autocomplete
                  placeholder="Add feature and press enter"
                  minQueryLength={1}
                  allowDeleteFromEmptyInput={false}
                  allowUnique={true}
                  classNames={{
                    tags: 'tags-container',
                    tagInput: 'tag-input',
                    tag: 'tag',
                    remove: 'tag-remove',
                    suggestions: 'tag-suggestions'
                  }}
                />
            </FormGroup>
            
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="is_active"
                  checked={newPlan.is_active}
                  onChange={handleInputChange}
                />{' '}
                Active Plan
              </Label>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleModal}>Cancel</Button>
            <Button color="primary" type="submit">
              {editingId ? 'Update Plan' : 'Save Plan'}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <style jsx global>{`
        /* Slider styles */
        .slick-slider {
          position: relative;
          display: block;
          box-sizing: border-box;
          user-select: none;
          touch-action: pan-y;
        }
        
        /* Tag input styles */
        .tags-container {
          position: relative;
          padding: 10px 0;
        }
        
        .tag-input {
          width: 100%;
          padding: 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
        }
        
        .tag {
          display: inline-block;
          background: #727cf5;
          color: white;
          padding: 5px 10px;
          border-radius: 20px;
          margin: 2px 5px 2px 0;
          font-size: 14px;
        }
        
        .tag-remove {
          color: white;
          margin-left: 5px;
          cursor: pointer;
        }
        
        .tag-suggestions {
          position: absolute;
          background: white;
          border: 1px solid #ddd;
          z-index: 1000;
          width: 100%;
        }
        
        /* Rest of your existing styles */
        .slick-list {
          position: relative;
          display: block;
          overflow: hidden;
          margin: 0;
          padding: 0;
        }
        
        .slick-track {
          position: relative;
          top: 0;
          left: 0;
          display: flex;
          margin-left: auto;
          margin-right: auto;
        }
        
        .slick-slide {
          height: auto;
          min-height: 1px;
          outline: none;
        }
        
        .slick-slide > div {
          height: 100%;
        }
        
        .slick-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 1;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(114, 124, 245, 0.2);
          border: none;
          color: #727cf5;
          font-size: 0;
          cursor: pointer;
        }
        
        .slick-arrow:before {
          font-family: 'slick';
          font-size: 20px;
          line-height: 1;
          opacity: 0.75;
          color: #727cf5;
        }
        
        .slick-prev {
          left: -20px;
        }
        
        .slick-next {
          right: -20px;
        }
        
        .slick-prev:before {
          content: '←';
        }
        
        .slick-next:before {
          content: '→';
        }
        
        .slick-dots {
          position: absolute;
          bottom: -30px;
          display: flex;
          justify-content: center;
          width: 100%;
          padding: 0;
          margin: 0;
          list-style: none;
        }
        
        .slick-dots li {
          margin: 0 5px;
        }
        
        .slick-dots li button {
          width: 10px;
          height: 10px;
          padding: 0;
          border: none;
          border-radius: 50%;
          background: #ccc;
          font-size: 0;
          cursor: pointer;
        }
        
        .slick-dots li.slick-active button {
          background: #727cf5;
        }
        
        .plan-card {
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          height: 100%;
        }
        
        .plan-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        }
        
        .plan-features {
          border-top: 1px solid #eee;
          padding-top: 15px;
        }
        
        .slider-container {
          padding: 0 30px;
        }
      `}</style>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(MembershipPlans);